import { useCallback } from 'react';
import { useAlertView } from '~/app';
import { openBillingPortal } from './api';
import { BillingPortalMode } from './types';

// Shared by every ActivationFeeDialog host (the B2B and service accept-fee
// hooks, the provider responses page) and BillingPage -- they all need the same
// "couldn't open billing, try again" fallback. Defaults to
// 'replace' (the Stripe deep link to the add-card step): the dialog only offers
// it when no method is on file. BillingPage passes 'manage' for "Manage
// payment methods".
export const useManagePaymentMethod = (mode: BillingPortalMode = 'replace') => {
  const alertView = useAlertView();

  return useCallback(async () => {
    try {
      await openBillingPortal({ mode });
    } catch (err) {
      console.error('Failed to open billing portal', err);
      alertView.send({
        type: 'ON_SHOW_ALERT',
        payload: {
          text: 'Could not open billing settings',
          subText: 'Please try again.',
          type: 'error',
          timeout: 5000,
        },
      });
    }
  }, [alertView, mode]);
};
